import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import '../App.css';
import { Link } from 'react-router-dom';
import { Grid } from "react-loader-spinner";
import { useTranslation } from 'react-i18next';
import WonAuctionBadge from './WonAuctionBadge';

class ChitCard extends React.Component {
  render() {
    const chit = this.props.chit;
    let nextAuctionDateObject = new Date(chit.next_auction_date);
    var options = { year: 'numeric', month: 'short', day: 'numeric', weekday: 'short' };
    let nextAuctionDate = nextAuctionDateObject.toLocaleDateString("en-IN", options);

    const formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'INR',

      // These options are needed to round to whole numbers if that's what you want.
      minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
    const totalAmount = formatter.format(chit.total_members * chit.per_person_amount);

    return (
      <Link to={`/chit/${chit.id}`}>
        <div className="max-w-sm rounded-md overflow-hidden shadow-lg px-6 py-4 bg-blue-300 mt-4 cursor-pointer">
          <div className="flex mb-2">
            <div className="font-bold text-gray-800 text-xl mr-2">{nextAuctionDate}</div>
            <div className="rounded-md h-6 w-6 flex items-center justify-center bg-blue-200 text-gray-800">
              {chit.next_installment_count}
            </div>
          </div>
          <div className="flex flex-row justify-between">
            <div className="flex flex-col w-10/12 break-words">
              <div className="text-gray-800 text-base">
                {chit.chit_name}
                <WonAuctionBadge showBadge={chit.won_installment_number != null} />
              </div>
              <div className="text-gray-800 text-base mt-1">{totalAmount}</div>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

class CompletedChits extends React.Component {
  render() {
    const rows = [];

    this.props.chits.forEach(chit => {
      rows.push(
        <ChitCard key={chit.id} chit={chit} />
      );
    });

    return (
      <div className="mx-auto sm:max-w-xs mb-4">
        <h4 className="text-lg font-extrabold mt-4 tracking-normal">{this.props.t('button.completedChits')}</h4>
        {rows}
      </div>
    );
  }
}

const CompletedChitsList = () => {
  const { t } = useTranslation();
  const [chits, setChits] = useState([]);
  const [errorText, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCompletedChits().catch(console.error);
  }, []);

  const fetchCompletedChits = async () => {
    let { data: chits, error } = await supabase
      .from("chits")
      .select("*")
      .is('is_completed', true)
      .order('next_auction_date', { ascending: false });
    if (error) {
      setError("No chits were completed yet");
      setLoading(false);
      console.log("error", error);
    } else {
      setChits(chits);
      setLoading(false);
    }
  }

  return (
    <div className="container flex flex-col justify-center">
      {
        loading ?
          <div className="container flex px-4 py-4 mt-8 text-lg font-medium">
            <p className="mx-auto">
              <Grid type="Grid" color="#93C5FD" height="32" width="32" />
            </p>
          </div> :
          errorText ?
            <div className="container flex content-center px-4 py-4 text-lg font-medium">
              <p className="mx-auto">{errorText}</p>
            </div> :
            <div className="flex justify-center">
              <div className="w-10/12 sm:max-w-xs">
                {
                  (chits.length > 0) ? <CompletedChits chits={chits} t={t} /> :
                    <div className="container flex px-4 py-4 text-lg font-medium">
                      <p className="mx-auto">{t('text.chitsIncompleteMessage')}</p>
                    </div>
                }
              </div>
            </div>
      }
    </div >
  );
}

export default CompletedChitsList;
